export default function countDecimals(value) {
  if (Math.floor(value) === value) {
    return 0;
  }
  // Strip any non number values.
  const trimmedValue = value.toString().replace(/[a-zA-Z]/g, '');
  return trimmedValue.split('.')[1].length || 0;
}
